<template>
  <!-- dialog add docs -->
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'1000px'"
    :classDialog="'add-docs-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm sổ</h3>
      <el-row :gutter="24" class="flex-row flex__left">
      <el-col :span="12" class="flex-row flex__right">Ngày văn bản:</el-col>
      <el-col :span="12" class="flex-row">
        <el-date-picker
          class="style-fullWidth input-border__bottom input-border__radius__0"
          v-model="issuedBookDate"
          type="daterange"
          :prefix-icon="' '"
          placeholder="Chọn ngày văn bản để tìm kiếm"
          size="medium"
          format="dd/MM/yyyy"
          :picker-options="dateQuickFilterOption"
          range-separator="_"
          start-placeholder="_"
          end-placeholder="_"
          align="center"
          @change="search"
        ></el-date-picker>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="flex-row flex__left">
      <el-col :span="12" class="flex-row flex__right">Số đi:</el-col>
      <el-col :span="12" class="flex-row">
        <el-input
          placeholder="Nhập số đi để tìm kiếm"
          type="number"
          v-model="bookNumber"
          @change="search"
        />
      </el-col>
    </el-row>
      <div class="margin-bottom-10">
        <el-table
          ref="addIssuedBookNumberTable"
          :data="issuedBookNumbers"
          size="mini"
          stripe
          style="width: 100%"
          max-height="700"
          highlight-current-row
          @current-change="handleCurrentChange"
        >
          <el-table-column width="40" type="index">
            <template #header>#</template>
          </el-table-column>

          <el-table-column
            label="Tên sổ"
            show-overflow-tooltip
            sortable
            property="vbDocInBookBookName"
          >
            <template slot-scope="scope">
              <span @click="itemClicked(scope.row)">{{scope.row.vbDocInBookBookName}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Số đi"
            show-overflow-tooltip
            sortable
            property="bookNumber"
            width="100"
          >
            <template slot-scope="scope">
              <span @click="itemClicked(scope.row)">{{scope.row.bookNumber?(9>=scope.row.bookNumber >= 1?
                "0"+scope.row.bookNumber:scope.row.bookNumber):""
                }}
</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Số phụ"
            show-overflow-tooltip
            sortable
            property="subBookNumber"
            width="100"
          >
            <template slot-scope="scope">
              <span @click="itemClicked(scope.row)">{{scope.row.subBookNumber}}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Trích yếu"
            show-overflow-tooltip
            sortable
            property="quote"
            width="250"
          >
            <template slot-scope="scope">
              <span @click="itemClicked(scope.row)">{{
                  scope.row.quote
                }}</span>
            </template>
          </el-table-column>

<!--          <el-table-column-->
<!--            label="Trạng thái"-->
<!--            show-overflow-tooltip-->
<!--            sortable-->
<!--            property="status"-->
<!--            width="120"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--              <span @click="itemClicked(scope.row)">{{getStatusLabel(scope.row.status) || "-"}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->

          <el-table-column
            property="docDate"
            label="Ngày văn bản"
            sortable
            width="120"
          >
            <template slot-scope="scope">
              <div
                class="flex-row flex__left"
                @click="itemClicked(scope.row)"
              >
                <p>{{scope.row.docDate | dateFormatter({dateFormat: "DD/MM/YYYY"})}}</p>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            property="createTime"
            label="Ngày tạo"
            sortable
            width="120"
          >
            <template slot-scope="scope">
              <div
                class="flex-row flex__left"
                @click="itemClicked(scope.row)"
              >
                <p>{{scope.row.createTime | dateFormatter({dateFormat: "DD/MM/YYYY"})}}</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          type="info"
          size="mini"
          class="el-button dialogBtnPrimary el-button--default"
          @click="submit"
        >Chọn
        </el-button>
        <el-button
          type="info"
          size="mini"
          class="btn__cancel btn-none__border"
          @click="cancel"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import dateFormatter from "../../../filters/dateFormatter";
import constants from "../../../constants";
import dateUtils from "../../../dateUtils";
import vbOutgoingDocInBookViewService from "../../../services/vbOutgoingDocInBookViewService";
import bookService from "../../../services/bookService";

export default {
  name: "dialog-add-book-number",
  props: ["isOpen", "bookId"],
  filters: {dateFormatter},
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue")
  },
  data() {
    return {
      docTypeVbDi: null,
      docTypeVbDen: null,
      docType: null,
      issuedBookDate: null,
      bookNumber: null,
      docs: null,
      selectedBookDocNumber: null,
      listBookDocs: [],
      issuedBookNumbers:[],
      advanceSearchForm: {
        fromDocDate: null,
        toDocDate: null,
        bookId: null,
        bookNumber: null
      },
      dateQuickFilterOption: {
        shortcuts: [
          {
            text: "Hôm nay",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.HOM_NAY
                )
              );
            }
          },
          {
            text: "Tuần này",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.TUAN_NAY
                )
              );
            }
          },
          {
            text: "Năm nay",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.NAM_NAY
                )
              );
            }
          },
          {
            text: "1 tuần trước",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.LAST_WEEK
                )
              );
            }
          },
          {
            text: "1 tháng trước",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
                )
              );
            }
          },
          {
            text: "1 năm trước",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
                )
              );
            }
          }
        ]
      },
    };
  },

  async created() {
    this.docTypeVbDi = constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DI;
    this.docTypeVbDen = constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN;
    this.docType = constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN;
    await this.initSignerTimeRange();
    await this.getListBookDocs();
    await this.search();
  },

  methods: {
    getCurrentNumber(bookDoc) {
      switch (bookDoc.bookDocStatus) {
        case constants.BOOKDOC.STATUS.DA_BOOK:
          return bookDoc.currentNumbers;
        default:
          return bookDoc.bookDocStatus;
      }
    },

    getDaiSoDaBook(bookDoc) {
      return [bookDoc.fromNumber, bookDoc.toNumber].join("-");
    },

    itemClicked(item) {
      this.$refs.addIssuedBookNumberTable.toggleRowSelection(item);
    },

    submit() {
      this.$emit("submit", {
        bookDocNumber: this.selectedBookDocNumber
      });
    },

    cancel() {
      this.$emit("closeDialog");
    },

    handleCurrentChange(val) {
      this.selectedBookDocNumber = val;
    },

    getListBookDocs() {
      return bookService
        .findAll({bookType: constants.BOOK_TYPE.VB_DI})
        .then(response => {
          let items = response.data;
          items && (this.listBookDocs = this.listBookDocs.concat(items));
        })
    },

    search() {
      this.advanceSearchForm.fromDocDate =
        this.issuedBookDate && this.issuedBookDate[0]
          ? this.issuedBookDate[0].getTime()
          : undefined;
      this.advanceSearchForm.toDocDate =
        this.issuedBookDate && this.issuedBookDate[1]
          ? this.issuedBookDate[1].getTime()
          : undefined;
      this.advanceSearchForm.bookId = this.bookId;
      this.advanceSearchForm.bookNumber = this.bookNumber;

      return vbOutgoingDocInBookViewService
        .findAll2(this.advanceSearchForm, {sort: "docDate,desc"})
        .then(response => {
          this.issuedBookNumbers = response.data;
        });
    },

    getStatusLabel(status) {
      if (status === constants.OUTGOING_DOC_STATUS.TAOMOI) return "Tạo mới";
      if (status === constants.OUTGOING_DOC_STATUS.DABANHANH)
        return "Đã ban hành";
      if (status === constants.OUTGOING_DOC_STATUS.DANGXULI)
        return "Đang xử lý";
      if (status === constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH)
        return "Chờ ban hành";
      if (status === constants.OUTGOING_DOC_STATUS.TU_CHOI) return "Từ chối";
      if (status === constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH)
        return "Từ chối Ban hành";
      return status;
    },

    initSignerTimeRange() {
      if (
        this.advanceSearchForm.fromDocDate ||
        this.advanceSearchForm.toDocDate
      ) {
        this.issuedBookDate = [
          dateUtils.toMoment(this.advanceSearchForm.fromDocDate),
          dateUtils.toMoment(this.advanceSearchForm.toDocDate)
        ];
      } else {
        this.issuedBookDate = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
        this.advanceSearchForm.fromDocDate = defaultTimeRange[0];
        this.advanceSearchForm.toDocDate = defaultTimeRange[1];
      }
    },
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/components/dialog-add-issued-book-number.vue